import * as React from 'react';

// Native CSS aspect-ratio. Three opinionated combinations: 1/1 (square),
// 16/9 (video), 4/3 (standard). Anything else throws — picking from a
// curated palette is the design-system stance, and zero production
// callsites today means there is no demand for arbitrary ratios. Lift
// the whitelist when one shows up.

const SUPPORTED_RATIOS = [
    [1, 1],
    [16, 9],
    [4, 3]
];

const formatSupportedRatios = () => SUPPORTED_RATIOS
    .map(([sx, sy]) => `${sx}/${sy}`)
    .join(', ');

const isSupportedRatio = (x, y) => SUPPORTED_RATIOS.some(([sx, sy]) => sx === x && sy === y);

const AspectRatio = React.forwardRef(({ children, className: _className, style: _style, x, y, ...rest }, ref) => {
    if (!isSupportedRatio(x, y)) {
        throw new Error(`AspectRatio: ${x}/${y} is not supported. Allowed: ${formatSupportedRatios()}.`);
    }

    return (
        <div ref={ref} style={{ aspectRatio: `${x} / ${y}` }} {...rest}>
            {children}
        </div>
    );
});

AspectRatio.displayName = 'AspectRatio';

export { AspectRatio };
